import { IRoutes, IServiceMenuComponent } from '@/interfaces/interfaceCatalogs';
import { InputSwitchChangeEvent } from 'primereact/inputswitch';
import { classNames } from 'primereact/utils';

import { ButtonComponent } from '../../../../components/ButtonComponen';
import { InputComponent } from '../../../../components/InputComponent';
import { SwitchComponent } from '../../../../components/SwitchComponent';
import { RoutesValidations } from './validations_form';
import useCustomFormik from './utils/formik_catalog_Config';

export const RoutesForm = (props: IServiceMenuComponent) => {
  const { serviceCatalog } = props;

  const renderMenu = (): any => {
    return (
      <form
        className="h-full w-full flex flex-col pt-5 px-6"
        onSubmit={serviceCatalog.formikRoutes.handleSubmit}>
        <div className="flex flex-col">
          <InputComponent
            label={'Nombre'}
            type={'name'}
            name={'name'}
            onChange={serviceCatalog.formikRoutes.handleChange}
            value={serviceCatalog.formikRoutes?.values?.['name'] || ''}
            placeholder={'Nombre'}
            className={classNames({
              'p-invalid': serviceCatalog.isFormFieldValid('name', serviceCatalog.formikRoutes.errors, serviceCatalog.formikRoutes.touched),
            })}
          />
          {serviceCatalog.getFormErrorMessage('name', serviceCatalog.formikRoutes.errors, serviceCatalog.formikRoutes.touched)}
        </div>

        <div className="flex flex-col">
          <InputComponent
            label={'Número de ruta'}
            type={'routeNumber'}
            name={'routeNumber'}
            onChange={serviceCatalog.formikRoutes.handleChange}
            value={serviceCatalog.formikRoutes?.values?.['routeNumber'] || ''}
            placeholder={'Número de ruta'}
            className={classNames({
              'p-invalid': serviceCatalog.isFormFieldValid('routeNumber', serviceCatalog.formikRoutes.errors, serviceCatalog.formikRoutes.touched),
            })}
          />
          {serviceCatalog.getFormErrorMessage('routeNumber', serviceCatalog.formikRoutes.errors, serviceCatalog.formikRoutes.touched)}
        </div>

        <div className="flex flex-col">
          <SwitchComponent
            checked={serviceCatalog.formikRoutes?.values?.['status'] || 'false'}
            onChange={(e: InputSwitchChangeEvent) => {
              serviceCatalog.formikRoutes.setFieldValue('status', e.value);
            }}
            label={'Estatus'}
            className={classNames({
              'p-invalid': serviceCatalog.isFormFieldValid('status', serviceCatalog.formikRoutes.errors, serviceCatalog.formikRoutes.touched),
            })}
          />
          {serviceCatalog.getFormErrorMessage('status', serviceCatalog.formikRoutes.errors, serviceCatalog.formikRoutes.touched)}
        </div>

        <ButtonComponent className="mt-10" label={serviceCatalog.buttonLabel} type="submit" />
      </form>
    );
  };

  return (
    <div className="flex w-full h-full flex-col items-center bg-white  shadow-[-6px_-1px_5px_#00000024] z-10 right-0">
      <div className="flex w-full h-full overflow-y-auto">{renderMenu()}</div>
    </div>
  );
};
